import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';


const FilterPopover = ({ filters, onFiltersChange, resultCount }) => {
  const [isOpen, setIsOpen] = useState(false);

  const modelOptions = [
    { value: 'all', label: 'Alle Modelle' },
    { value: 'GPT-4', label: 'GPT-4' },
    { value: 'GPT-3.5', label: 'GPT-3.5' },
    { value: 'Claude', label: 'Claude' },
    { value: 'Gemini', label: 'Gemini' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'Alle Zeiträume' },
    { value: 'today', label: 'Heute' },
    { value: 'week', label: 'Diese Woche' },
    { value: 'month', label: 'Dieser Monat' },
    { value: 'quarter', label: 'Dieses Quartal' },
    { value: 'year', label: 'Dieses Jahr' }
  ];

  const activityOptions = [
    { value: 'all', label: 'Alle Status' },
    { value: 'active', label: 'Nur aktive' },
    { value: 'inactive', label: 'Nur inaktive' }
  ];

  const availableTags = [
    'Kundenservice', 'Verkauf', 'Support', 'Marketing', 'E-Commerce', 
    'Bildung', 'Gesundheit', 'Finanzen', 'Immobilien', 'Technologie'
  ];

  const handleTagToggle = (tag) => {
    const newTags = filters?.tags?.includes(tag)
      ? filters?.tags?.filter(t => t !== tag)
      : [...filters?.tags, tag];
    
    onFiltersChange({ ...filters, tags: newTags });
  };

  const clearAllFilters = () => {
    onFiltersChange({
      tags: [],
      model: 'all',
      dateRange: 'all',
      activity: 'all'
    });
  };

  const hasActiveFilters = filters?.tags?.length > 0 || 
                          filters?.model !== 'all' || 
                          filters?.dateRange !== 'all' || 
                          filters?.activity !== 'all';

  return (
    <div className="relative">
      <Button
        variant={hasActiveFilters ? "default" : "outline"}
        size="sm"
        iconName="Filter"
        iconPosition="left"
        onClick={() => setIsOpen(!isOpen)}
        className="relative"
      >
        Filter
        {hasActiveFilters && (
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-primary rounded-full" />
        )}
      </Button>
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 top-full mt-2 w-80 bg-popover border border-border rounded-lg shadow-lg z-50 animate-scale-in">
            <div className="p-4">
              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-popover-foreground">Filter</h3>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-muted-foreground">
                    {resultCount} Ergebnisse
                  </span>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => setIsOpen(false)}
                    iconName="X"
                    className="w-6 h-6 p-0"
                  />
                </div>
              </div>

              {/* Tags Filter */}
              <div className="mb-4">
                <label className="text-sm font-medium text-popover-foreground mb-2 block">
                  Tags
                </label>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {availableTags?.map((tag) => (
                    <Checkbox
                      key={tag}
                      label={tag}
                      checked={filters?.tags?.includes(tag)}
                      onChange={() => handleTagToggle(tag)}
                      size="sm"
                    />
                  ))}
                </div>
              </div>

              {/* Model Filter */}
              <div className="mb-4">
                <Select
                  label="AI-Modell"
                  options={modelOptions}
                  value={filters?.model}
                  onChange={(value) => onFiltersChange({ ...filters, model: value })}
                />
              </div>

              {/* Date Range Filter */}
              <div className="mb-4">
                <Select
                  label="Erstellungsdatum"
                  options={dateRangeOptions}
                  value={filters?.dateRange}
                  onChange={(value) => onFiltersChange({ ...filters, dateRange: value })}
                />
              </div>

              {/* Activity Filter */}
              <div className="mb-4">
                <Select
                  label="Aktivitätsstatus"
                  options={activityOptions}
                  value={filters?.activity}
                  onChange={(value) => onFiltersChange({ ...filters, activity: value })}
                />
              </div>

              {/* Actions */}
              <div className="flex space-x-2 pt-2 border-t border-border">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={clearAllFilters}
                  disabled={!hasActiveFilters}
                  className="flex-1"
                >
                  Zurücksetzen
                </Button>
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => setIsOpen(false)}
                  className="flex-1"
                >
                  Anwenden
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FilterPopover;